import { useState } from "react"
import Popover from "@/v2-ui/popover"
import Button from "@/v2-backoffice-client/components/button"
import DateRangePicker from "@/v2-backoffice-client/components/dateRangePicker"
import {
  formatDateRangeLabel,
  type DateRangeValue,
} from "@/v2-backoffice-client/components/dateRangePicker"

export type DateFilterProps = {
  value: DateRangeValue | undefined
  onChange(value?: DateRangeValue): void
  minDate?: Date
  maxDate?: Date
  disablePast?: boolean
  disableFuture?: boolean
}

function DateFilter(props: DateFilterProps) {
  const { value, onChange, minDate, maxDate, disablePast, disableFuture } =
    props

  const [open, setOpen] = useState(false)
  const [resetKey, setResetKey] = useState(0)

  const triggerLabel = value ? formatDateRangeLabel(value) : "Pick date"

  return (
    <Popover
      open={open}
      onOpenChange={(isOpen) => {
        if (isOpen) setResetKey((k) => k + 1)
        setOpen(isOpen)
      }}
    >
      <Popover.Trigger asChild>
        <Button
          variant="secondary"
          size="xs"
          className="ui-table-filter-input"
          iconSrc="calendar"
          iconSize={12}
        >
          {triggerLabel}
        </Button>
      </Popover.Trigger>

      <Popover.Content
        className="ui-date-filter-content"
        spacing={false}
        size="fit"
        align="start"
      >
        <DateRangePicker
          key={resetKey}
          value={value}
          minDate={minDate}
          maxDate={maxDate}
          disablePast={disablePast}
          disableFuture={disableFuture}
          onApply={(v) => {
            onChange(v)
            setOpen(false)
          }}
          onClear={() => {
            onChange()
          }}
          onCancel={() => setOpen(false)}
        />
      </Popover.Content>
    </Popover>
  )
}

export default DateFilter
